export default class Language {
  private Language: string;
  private Months: string[];
  private MonthsAbbr: string[];
  private Days: string[];
  private rtl: boolean;
  private ymd: boolean;
  private yearSuffix: string;

  constructor(language: string, months: string[], monthsAbbr: string[], days: string[]) {
    this.language = language;
    this.months = months;
    this.monthsAbbr = monthsAbbr;
    this.days = days;
    this.rtl = false;
    this.ymd = false;
    this.yearSuffix = '';
  }

  get language() {
    return this.Language;
  }

  set language(language) {
    if (typeof language !== 'string') {
      throw new TypeError('Language must be a string');
    }

    this.Language = language;
  }

  get months() {
    return this.Months;
  }

  set months(months) {
    if (months.length !== 12) {
      throw new RangeError(`There must be 12 months for ${this.language} language`);
    }
    this.Months = months;
  }

  get monthsAbbr() {
    return this.MonthsAbbr;
  }

  set monthsAbbr(monthsAbbr) {
    if (monthsAbbr.length !== 12) {
      throw new RangeError(`There must be 12 abbreviated months for ${this.language} language`);
    }
    this.MonthsAbbr = monthsAbbr;
  }

  get days() {
    return this.Days;
  }

  set days(days) {
    if (days.length !== 7) {
      throw new RangeError(`There must be 7 days for ${this.language} language`);
    }
    this.Days = days;
  }
}
